import * as React from 'react'

export function errorMsg (id: string, error: string) {
  const htmlId = `ImBoxNKIError-${id}`
  return (
    <div id={htmlId} className='input-error'>{error}</div>
  )
}
